.dialogStyle :global(.cp-container [role='dialog']) {
	z-index: 350;
}
